<ng-select [items]="types$ | async"
           bindLabel="label"
           bindValue="value"
           placeholder="{{'common.all' | translate}}"
           [(ngModel)]="selectedType"
           [searchable]="false">
    <ng-template ng-label-tmp let-item="item">
        <span>{{ 'DeviceType.' + item.label | translate}}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
        <span>{{ 'DeviceType.' + item.label | translate}}</span>
    </ng-template>

</ng-select>
